import { type FC } from 'react';

/** Compact card icon for integration scenario tiles (outline). */
export const IntegrationScenarioCardIcon: FC = () => (
  <svg width={22} height={17} viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M1.375 4.25C1.375 2.76609 2.57959 1.5625 4.0625 1.5625H17.9375C19.4204 1.5625 20.625 2.76609 20.625 4.25V12.75C20.625 14.2339 19.4204 15.4375 17.9375 15.4375H4.0625C2.57959 15.4375 1.375 14.2339 1.375 12.75V4.25Z"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.375 6.60938H20.625" stroke="currentColor" strokeWidth="1.375" strokeLinecap="round" />
    <path
      d="M5.84375 11.7812H8.9375"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
